import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { LoginContext } from '../context/LoginContext';
import {
  getUserStatus,
  needsCreateProfile,
  needsDesiredPartner,
} from '../utils/onboarding';

/**
 * Member pages (matches, search, chat, etc.) — only fully active status 1.
 */
export function RequireActiveMember({ children }) {
  const { isLoggedIn, userData } = useContext(LoginContext);

  if (!isLoggedIn) {
    return <Navigate to="/login/" replace />;
  }

  const status = getUserStatus(userData);

  if (status === 3) {
    return <Navigate to="/account-pending-approval" replace />;
  }
  if (needsCreateProfile(status) || status === null) {
    return <Navigate to="/create-profile" replace />;
  }
  if (needsDesiredPartner(status)) {
    return <Navigate to="/desired-partner" replace />;
  }
  if (status !== 1) {
    return <Navigate to="/create-profile" replace />;
  }

  return children;
}

/** Create profile — status 9, 0, or 3 (legacy early-pending still needs this form). */
export function RequireCreateProfile({ children }) {
  const { isLoggedIn, userData } = useContext(LoginContext);

  if (!isLoggedIn) {
    return <Navigate to="/login/" replace />;
  }

  const status = getUserStatus(userData);

  if (status === 8) {
    return <Navigate to="/desired-partner" replace />;
  }
  if (status === 1) {
    return <Navigate to="/recently-joined-matches/" replace />;
  }

  return children;
}

/** Desired partner — status 8 only (profile done, partner form pending). */
export function RequireDesiredPartner({ children }) {
  const { isLoggedIn, userData } = useContext(LoginContext);

  if (!isLoggedIn) {
    return <Navigate to="/login/" replace />;
  }

  const status = getUserStatus(userData);

  if (status === 3) {
    return <Navigate to="/account-pending-approval" replace />;
  }
  if (needsCreateProfile(status) || status === null) {
    return <Navigate to="/create-profile" replace />;
  }
  if (status === 1) {
    return <Navigate to="/recently-joined-matches/" replace />;
  }
  if (!needsDesiredPartner(status)) {
    return <Navigate to="/create-profile" replace />;
  }

  return children;
}
